import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
var StripePaymentLoadKeyMap = {
  UK: process.env['NX_STRIPE_PUBLISHABLE_KEY'],
  US: process.env['NX_US_STRIPE_PUBLISHABLE_KEY'],
  EU: process.env['NX_EU_STRIPE_PUBLISHABLE_KEY']
};
export var useQuoteStripePayment = function useQuoteStripePayment(quoteId, config) {
  var _useState = useState(),
      stripePromise = _useState[0],
      setStripePromise = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    evaluateStripePromise(config === null || config === void 0 ? void 0 : config.stripePayOperationKey);
  }, []); // Get stripePromise instance

  var evaluateStripePromise = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stripePayOperationKey) {
      var stripeKey, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              stripeKey = StripePaymentLoadKeyMap[stripePayOperationKey] || StripePaymentLoadKeyMap.UK;
              _context.next = 3;
              return loadStripe(stripeKey);

            case 3:
              data = _context.sent;
              setStripePromise(data);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function evaluateStripePromise(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    stripePromise: stripePromise
  };
};